import { StyledNGSquareButton } from 'src/styles/theme/components/NGSquareButton/NGSquareButton.styles';
import { ESize } from 'src/styles/theme/utils/enums';
import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledButton = styled.button<{
	padding?: ESize;
	fullWidth?: boolean;
	paddingBottom?: ESize;
	paddingTop?: ESize;
	paddingLeft?: ESize;
	paddingRight?: ESize;
	paddingX?: ESize;
	paddingY?: ESize;
}>`
	${(p) => css`
		display: flex;
		justify-content: flex-start;
		align-items: center;

		${p.fullWidth ? `width: 100%;` : 'width: auto;'}

		${p.padding !== ESize.unset
			? `
		padding: 14px 16px;
		margin-top: 6px;
		`
			: ''}

		border: none;
		background: none;
		cursor: pointer;

		${p.padding ? `padding: ${p.theme.spacing[p.padding]};` : ''}
		${p.paddingX ? `padding-left: ${p.theme.spacing[p.paddingX]}; padding-right: ${p.theme.spacing[p.paddingX]};` : ''}
		${p.paddingY ? `padding-top: ${p.theme.spacing[p.paddingY]}; padding-bottom: ${p.theme.spacing[p.paddingY]};` : ''}
		${p.paddingTop ? `padding-top: ${p.theme.spacing[p.paddingTop]};` : ''}
		${p.paddingBottom ? `padding-bottom: ${p.theme.spacing[p.paddingBottom]};` : ''}
		${p.paddingLeft ? `padding-left: ${p.theme.spacing[p.paddingLeft]};` : ''}
		${p.paddingRight ? `padding-right: ${p.theme.spacing[p.paddingRight]};` : ''}
	`}
`;

export const StyledSpan = styled.span<{ textTruncate?: boolean }>`
	display: block;

	${(p) => (p.textTruncate ? `text-overflow: ellipsis; overflow: hidden; width: calc(100% - 16px);` : '')}
`;

export const StyledIconsContainer = styled.div<{ isActive: boolean }>`
	position: relative;

	display: flex;
	justify-content: center;
	align-items: center;

	width: 20px;

	& > span {
		position: absolute;
		${addTransition()}

		${(p) =>
			p.isActive
				? css`
						&:nth-child(1) {
							opacity: 0;
							transform: translateY(-50%) rotate(45deg);
						}
						&:nth-child(2) {
							opacity: 1;
							transform: translateY(0) rotate(0);
						}
				  `
				: css`
						&:nth-child(1) {
							opacity: 1;
							transform: translateY(0) rotate(0);
						}
						&:nth-child(2) {
							opacity: 0;
							transform: translateY(50%) rotate(-45deg);
						}
				  `}
	}
`;

export const StyledOnHoverContainer = styled.div`
	position: relative;
	width: 100%;

	${addTransition()}

	& ${StyledNGSquareButton} {
		position: absolute;
		bottom: 10px;
		right: calc(5% + 10px);

		opacity: 0;
	}

	@media (hover: hover) {
		&:hover {
			& ${StyledNGSquareButton} {
				opacity: 1;
			}
		}
	}
`;
